module.exports = __webpack_public_path__ + "img/644.de13e0df.png";